export default __webpack_public_path__ + "static/media/obyektiy.39d06516.svg";